<template>
    <div class="service_main" :class="{'cn':version == '1'}">
        <div class="service_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="service_right">
            <div class="service_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId" @change="buildIdChange()">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="floorId" @change="floorIdChange()">
                        <!-- <el-option :key="''" :label="'All floor'" :value="''"></el-option> -->
                        <el-option
                            v-for="item in floorNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="roomId" @change="roomIdChange()">
                        <!-- <el-option :key="''" :label="'All room'" :value="''"></el-option> -->
                        <el-option
                            v-for="item in roomNav"
                            :key="item.id"
                            :label="item.number"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="deviceType" @change="deviceTypeChange()">
                        <el-option
                            v-for="item in deviceTypeNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="deviceStatus" @change="deviceTypeChange()">
                        <el-option
                            v-for="item in deviceStatusNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                        <!-- <el-option key="0" :label="$t('App.service.text1')" value="0"></el-option>
                        <el-option key="0" :label="$t('App.service.text1')" value="0"></el-option>
                        <el-option key="0" :label="$t('App.service.text1')" value="0"></el-option> -->
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getServiceListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getServiceListKeyUp({key:'Enter'})"></i>
                    </el-input>
                </div>
                <div class="right_top_r">
                    <div class="btn" @click="linkToFun('/pushSetting')">
                        <img :src="img_centralizedSetting">
                        <span>{{$t('App.service.text2')}}</span>
                    </div>
                    <div class="btn" @click="linkToFun('/maintenanceStaff')">
                        <img :src="img_newMaintenanceStaff">
                        <span>{{$t('App.service.text3')}}</span>
                    </div>
                </div>
            </div>
            <div class="service_echarts_box">
                <div class="service_title">
                    <span class="text">{{$t('App.sideBar.text11')}}</span>
                    <div class="flex_box">
                        <el-dropdown @command="commandTimeType" trigger="click" @visible-change="commandHide('dropdown_service_timeType')">
                            <span class="span1">{{commandTimeTypeName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_service_timeType">
                                <el-dropdown-item v-for="item in timeTypeArr" :command="item" :key="'room'+item.id" :class="{'select':item.id==timeType}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="time_box">
                            <el-date-picker
                                v-if="timeType == '0'"
                                v-model="daysDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :picker-options="pickerOptions"
                                @change="dateChange()"
                                placeholder="">
                            </el-date-picker>

                            <el-date-picker
                                v-if="timeType == '1'"
                                v-model="monthDate"
                                value-format="yyyy-MM"
                                type="month"
                                @change="dateChange()"
                                :picker-options="pickerOptions"
                                placeholder="">
                            </el-date-picker>

                                <!-- format="yyyy" -->
                            <el-date-picker
                                v-if="timeType == '2'"
                                v-model="yearDate"
                                value-format="yyyy"
                                type="year"
                                @change="dateChange()"
                                :picker-options="pickerOptions"
                                placeholder="">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="echarts_service"></div>
            </div>
            <div class="service_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                        <div class="btn" @click="postDelService(checkList,'batch')">
                            <i class="iconfont icon-delete"></i>
                            <span>{{$t('App.lights.text1')}}</span>
                        </div>
                        <div class="btn" @click="postDelService(checkList,'batch',1)">
                            <!-- <i class="iconfont icon-delete"></i> -->
                            <span>{{$t('App.service.text68')}}</span>
                        </div>

                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="linkToFun('/alarmProfile')">
                            <img :src="img_centralizedSetting">
                            <span>{{$t('App.service.text4')}}</span>
                        </div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="serviceDataList"
                            v-loading="loading.serviceDataList"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            height="100%"
                            :data="serviceDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="100">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in lightArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <span v-if="item.type != 1">{{scope.row[item.prop]}}</span>
                                        <div v-if="item.prop == 'type'" class="device_type">{{deviceTypeArr[scope.row[item.prop]]}}</div>
                                        <div v-if="item.prop == 'status'" class="maintenanceStatus">
                                            <span :class="'text_'+scope.row[item.prop]">{{statusArr[scope.row[item.prop]]}}</span>
                                        </div>
                                        <div v-if="item.prop == 'is_cancel'">{{deviceIsCancelArr[scope.row[item.prop]]}}</div>
                                        
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="100"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="maintenanceInformationFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                     
                                    <span class="btn" @click="repairFun(scope.row)" v-if="scope.row.status == '0'" :title="$t('App.service.text5')">
                                        <i class="iconfont icon-weixiu1"></i>
                                    </span>
                                    <span class="btn" @click="repairDeal(scope.row)" v-if="scope.row.status == '1'" :title="$t('App.service.text6')">
                                        <i class="iconfont icon-biaojichuli"></i>
                                    </span>
                                    <span class="btn">
                                        <i class="iconfont icon-delete" @click="postDelService(scope.row)" :title="$t('App.lights.text1')"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="maintenanceInformation_wrap scrollbar_style" v-show="maintenanceInformationTkShowbg">
            <div class="maintenanceInformation_wrap_bg" @click="maintenanceInformationTkClose()"></div>
            <div class="maintenanceInformation_box" :class="{'maintenanceInformation_tk_show':maintenanceInformationTkShow}">
                <div class="maintenanceInformation_title">
                    <span class="span1">{{$t('App.service.text7')}}</span>
                    <span class="span2" @click="maintenanceInformationTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-input v-model="serviceForm.floor" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-input v-model="serviceForm.room" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="serviceForm.name" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text18')}}</span>
                        <el-input v-model="serviceForm.deviceId" disabled></el-input>
                    </div>
                    <div class="form_item fault">
                        <span class="laber">{{$t('App.service.text8')}}</span>
                        <el-input v-model="serviceForm.content" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.service.text9')}}</span>
                        <el-input v-model="serviceForm.repairName" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.service.text10')}}</span>
                        <el-input v-model="serviceForm.completion" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.service.text11')}}</span>
                        <el-input v-model="serviceForm.updatetime" disabled></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="maintenanceInformationTkClose()">{{$t('App.room.text28')}}</div>
                </div>
            </div>
        </div>
        <div class="repair_wrap scrollbar_style" v-show="repairTkShowbg">
            <div class="repair_wrap_bg" @click="repairTkClose()"></div>
            <div class="repair_box" :class="{'repair_tk_show':repairTkShow}">
                <div class="repair_title">
                    <span class="span1">{{$t('App.service.text12')}}</span>
                    <span class="span2" @click="repairTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="repairForm.name" disabled placeholder="Please enter room number"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-input v-model="repairForm.floor" disabled placeholder="Please enter room number"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-input v-model="repairForm.roomNumber" disabled placeholder="Please enter room number"></el-input>
                    </div>
                    <div class="form_item fault">
                        <span class="laber">{{$t('App.service.text8')}}</span>
                        <el-input v-model="repairForm.content" disabled placeholder="Please enter room number"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.service.text13')}}</span>
                        <el-dropdown @command="commandRepairId" trigger="click" @visible-change="commandHide('dropdown_service_repairId')">
                            <span class="span1">{{commandRepairName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_service_repairId">
                                <el-dropdown-item v-for="item in repairNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==repairForm.repairId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="repairDispatch()">{{$t('App.service.text12')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'
    export default {
        name:'service',
        data () {
            return{
                buildId:'',
                floorId:'',
                roomId:'',
                deviceType:'',
                deviceStatus:'0',
                keywords:'',
                buildNav:[],
                floorNav:[],
                roomNav:[],
                deviceTypeNav:[{id:'',name:'All equipment'},{id:'0',name:'Lights'},{id:'1',name:'Circadian lights'},{id:'2',name:'Sensor'},{id:'3',name:'Air purifiers'}],
                deviceStatusNav:[],

                deviceTypeArr:['Lights','Circadian lights','Sensor','Air purifiers'],

                daysDate:new Date(),
                monthDate:new Date(),
                yearDate:new Date(),
                timeType:'2',
                timeTypeArr:[{name:'Daily',id:'0'},{name:'Monthly',id:'1'},{name:'Yearly',id:'2'}],
                repairForm:{
                    id:'',
                    name:'',
                    floor:'',
                    roomNumber:'',
                    content:'',
                    repairId:'',
                },
                repairNav:[],

                serviceForm:{
                    floor:'',
                    room:'',
                    name:'',
                    deviceId:'',
                    content:'',
                    repairName:'',
                    completion:'',
                    updatetime:'',
                },

                value4:'54454',
                options:[],
                input3:'',

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                lightArr:[],
                serviceDataList:[],
                serviceDataIdList:[],
                statusArr:['No maintenance','Maintenance','Repaired'],
                deviceIsCancelArr:[],

                currentPage:1,
                pageSize:20,
                total:1000,

                repairTkShowbg:false,
                repairTkShow:false,

                maintenanceInformationTkShowbg:false,
                maintenanceInformationTkShow:false,

                myChart1:null,

                loading:{
                    serviceDataList:false,
                },
                
                pickerOptions:{
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },

                img_centralizedSetting:'',
                img_newMaintenanceStaff:'',

            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            commandTimeTypeName(){
                let name = '';
                for(let d of this.timeTypeArr){
                    if(d.id == this.timeType){
                        name = d.name
                    }
                }
                return name;
            },
            commandRepairName(){
                let name = '';
                for(let d of this.repairNav){
                    console.log(d,this.repairForm.repairId)
                    if(d.id == this.repairForm.repairId){
                        name = d.name
                    }
                }
                return name;
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        mounted(){

            this.img_centralizedSetting = require('../../img/centralizedSetting.png');
            this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff.png');
            if(this.version == '1'){
                this.img_centralizedSetting = require('../../img/centralizedSetting_v1.png');
                this.img_newMaintenanceStaff = require('../../img/newMaintenanceStaff_v1.png');
            }
            this.deviceTypeNav = [{id:'',name:this.$t('App.service.text1')},{id:'0',name:this.$t('App.sideBar.text7')},{id:'1',name:this.$t('App.sideBar.text8')},{id:'2',name:this.$t('App.sideBar.text15')},{id:'3',name:this.$t('App.sideBar.text9')}];
            this.deviceStatusNav = [{id:'0',name:this.$t('App.service.text1')},{id:'1',name:this.$t('App.service.text54')},{id:'2',name:this.$t('App.service.text52')},{id:'3',name:this.$t('App.service.text56')},{id:'4',name:this.$t('App.service.text57')},{id:'5',name:this.$t('App.service.text58')}];

            this.deviceTypeArr = [this.$t('App.sideBar.text7'),this.$t('App.sideBar.text8'),this.$t('App.sideBar.text15'),this.$t('App.sideBar.text9')];

            this.timeTypeArr = [{name:this.$t('App.room_light.text63'),id:'0'},{name:this.$t('App.room_light.text65'),id:'1'},{name:this.$t('App.room_light.text66'),id:'2'}];

            this.statusArr = [this.$t('App.service.text15'),this.$t('App.service.text16'),this.$t('App.service.text17')];
            this.deviceIsCancelArr = [this.$t('App.service.text60'),this.$t('App.service.text61')]

            this.daysDate = this.daysDate.format("YYYY-mm-dd");
            this.monthDate = this.monthDate.format("YYYY-mm");
            this.yearDate = this.yearDate.format("YYYY");
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            this.lightArr = [
                {prop:'type',label:this.$t('App.service.text18'),minWidth:120,type:1},
                {prop:'name',label:this.$t('App.room.text42'),minWidth:70},
                {prop:'deviceId',label:this.$t('App.room.text18'),minWidth:100},
                {prop:'floor',label:this.$t('App.room.text29'),minWidth:60},
                {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:60},
                {prop:'content',label:this.$t('App.service.text19'),minWidth:150},
                {prop:'status',label:this.$t('App.service.text20'),minWidth:150,type:1},
                {prop:'is_cancel',label:this.$t('App.service.text59'),width:130,type:1},
            ];

            var url = window.location.hash.split("?")[1]; //获取url中"?"符后的字串
            var theRequest = new Object();
            let floorId_ = null,roomId_ = null;
            if (url) {
                let arr = url.split("&");
                for (var i = 0; i < arr.length; i++) {
                    theRequest[arr[i].split("=")[0]] = decodeURIComponent(arr[i].split("=")[1]);
                }
                floorId_ = theRequest.floorId;
                roomId_ = theRequest.roomId;
                if(theRequest.deviceType){
                    this.deviceType = theRequest.deviceType;
                }
                if(theRequest.daysDate){
                    this.timeType = '0';
                    this.daysDate = theRequest.daysDate
                }
            }
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                    this.getFloorNav(()=>{
                        if(this.floorNav.length > 0){
                            if(floorId_){
                                this.floorId = floorId_;
                            }else{
                                this.floorId = this.floorNav[0].id;
                            }
                            this.getRoomNav(()=>{
                                if(this.roomNav.length > 0){
                                    if(roomId_){
                                        this.roomId = roomId_;
                                    }else{
                                        this.roomId = this.roomNav[0].id;
                                    }
                                }
                                this.getServiceList();
                                this.repairStatis();
                            })
                        }else{
                            this.roomNav = [];
                            this.roomId = '';
                            this.getServiceList();
                            this.repairStatis();
                        }
                    })
                }else{
                    this.buildId = '';
                    this.floorNav = [];
                    this.floorId = '';
                    this.roomNav = [];
                    this.roomId = '';
                    this.getServiceList();
                    this.repairStatis();
                }
            });

            // this.echartsService();
        },
        methods:{
            linkToFun(val){
                this.$router.push({path:val});
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:val,
                })
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            getRepairNav(devId){
                base.ajax_post(
                    allUrl.service.repairNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        devId:devId,
                    },
                    {},
                    data=>{
                        this.repairNav = data.data.list;
                    },
                    this
                )
            },
            commandRepairId(data){
                console.log(data)
                this.repairForm.repairId = data.id;
            },
            commandTimeType(data){
                this.timeType = data.id;
                this.getServiceList();
                this.repairStatis();
            },
            dateChange(){
                this.getServiceList();
                this.repairStatis();
            },
            deviceTypeChange(){
                this.getServiceList();
                this.repairStatis();
            },
            roomIdChange(){
                this.getServiceList();
                this.repairStatis();
            },
            floorIdChange(){
                this.getRoomNav(()=>{
                    if(this.roomNav.length > 0){
                        this.roomId = this.roomNav[0].id;
                    }else{
                        this.roomId = '';
                    }
                    this.getServiceList();
                    this.repairStatis();
                })
            },
            buildIdChange(){
                this.getFloorNav(()=>{
                    if(this.floorNav.length > 0){
                        this.floorId = this.floorNav[0].id;
                        this.getRoomNav(()=>{
                            if(this.roomNav.length > 0){
                                this.roomId = this.roomNav[0].id;
                            }
                            this.getServiceList();
                            this.repairStatis();
                        })
                    }else{
                        this.floorId = '';
                        this.roomNav = [];
                        this.roomId = '';
                        this.getServiceList();
                        this.repairStatis();
                    }
                })
            },
            /*删除设备*/
            postDelService(obj,type,type1){
                let alarmId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(alarmId == ''){
                                alarmId = id;
                            }else{
                                alarmId += ','+id;
                            }
                        }
                    }
                }else{
                    alarmId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        type1?this.$t('App.message.text39'):this.$t('App.message.text3'),this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.service.delAlarm,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                alarmId:alarmId,
                                type:type1,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getGatewayList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getServiceListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getServiceList();
                  this.repairStatis();
                }
            },
            getServiceList(callback){
                if(this.buildId){
                    let date;
                    if(this.timeType == '0'){
                        date = this.daysDate;
                    }
                    if(this.timeType == '1'){
                        date = this.monthDate;
                    }
                    if(this.timeType == '2'){
                        date = this.yearDate;
                    }
                    base.ajax_post(
                        allUrl.service.getList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            floorId:this.floorId,
                            roomId:this.roomId,
                            type:this.deviceType,
                            dateType:this.timeType,
                            date:date,
                            page:this.currentPage,
                            count:this.pageSize,
                            keywords:this.keywords,
                            status:this.deviceStatus,
                        },
                        {},
                        data=>{
                            this.serviceDataList = data.data.list;
                            this.total = Number(data.data.total);

                            this.serviceDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;
                            for(let d of this.serviceDataList){
                                this.serviceDataIdList.push(d.id);
                            }

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.serviceDataList){
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            maintenanceInformationFun(data){
                // console.log(data)
                this.maintenanceInformationTkShowbg = true;
                this.$nextTick(function(){
                    this.maintenanceInformationTkShow = true;
                })
                this.getAlarmInfo(data)
                
            },
            /*故障详情*/
            getAlarmInfo(obj){
                base.ajax_post(
                    allUrl.service.alarmInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        alarmId:obj.id,
                    },
                    {},
                    data=>{
                        for(let key in data.data){
                            this.serviceForm[key] = data.data[key];
                        }
                    },
                    this
                )
            },
            maintenanceInformationTkClose(){
                let this_ = this;
                this.maintenanceInformationTkShow = false;
                setTimeout(function(){
                    this_.maintenanceInformationTkShowbg = false;
                },1000)
            },
            repairFun(data){
                this.repairTkShowbg = true;
                this.$nextTick(function(){
                    this.repairTkShow = true;
                })
                this.getRepairNav(data.devId)
                // if(data.status == '0'){
                    for(let key in this.repairForm){
                        this.repairForm[key] = data[key]
                    }
                // }

            },
            repairTkClose(){
                let this_ = this;
                this.repairTkShow = false;
                setTimeout(function(){
                    this_.repairTkShowbg = false;
                },1000)
            },
            repairDispatch(){
                base.ajax_post(
                    allUrl.service.repairDispatch,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        alarmId:this.repairForm.id,
                        repairId:this.repairForm.repairId,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.getGatewayList();
                    },
                    this
                )
            },
            repairDeal(obj){
                this.$confirm(
                    this.$t('App.message.text26'), this.$t('App.message.text17'), {
                        confirmButtonText: this.$t('App.message.text2'),
                        cancelButtonText: this.$t('App.message.text6'),
                        type: 'warning'
                    }
                ).then(() => {
                    base.ajax_post(
                        allUrl.service.repairDeal,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            alarmId:obj.id,
                        },
                        {},
                        data=>{
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            this.getGatewayList();
                        },
                        this
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('App.message.text18')
                    });          
                });
            },
            repairStatis(){
                let date;
                if(this.timeType == '0'){
                    date = this.daysDate;
                }
                if(this.timeType == '1'){
                    date = this.monthDate;
                }
                if(this.timeType == '2'){
                    date = this.yearDate;
                }
                base.ajax_post(
                    allUrl.service.repairStatis,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        buildId:this.buildId,
                        floorId:this.floorId,
                        roomId:this.roomId,
                        type:this.deviceType,
                        dateType:this.timeType,
                        status:this.deviceStatus,
                        date:date,
                    },
                    {},
                    data=>{
                        this.echartsService(data.data);
                    },
                    this
                )
            },
            echartsService(data){
                console.log(data)

                let text1,text2;
                let date = null;
                if(this.timeType == '0'){
                    text1 = 20;
                    text2 = 44;
                }
                if(this.timeType == '1'){
                    date = this.monthDate.split('-')[1];
                }
                if(this.timeType == '2'){
                    date = this.monthDate.split('-')[0];
                    // date = this.yearDate;
                }
                let dataX = [],dataY = [];
                for(let i in data.dataList){
                    dataX.push(data.dateList[i])
                    let color = data.dataList[i]<90?(this.version == '1'?'#8266C7':'#05CFAB'):'#FF0C4D';
                    if(this.timeType == '0'){
                        if( i < text1 || i > text2 ){
                            // console.log(i)
                            color = '#EBEFF2';
                        }
                    }
                    if(this.timeType == '1'){
                        if( data.dateList[i].split('-')[0] != date){
                            color = '#EBEFF2';
                        }
                    }
                    if(this.timeType == '2'){
                        if( data.dateList[i].split('-')[0] != date){
                            color = '#EBEFF2';
                        }
                    }
                    dataY.push({
                        value:data.dataList[i],
                        itemStyle:{
                            color:color,
                        }
                    })
                }

                if(document.getElementsByClassName('echarts_service')[0]){
                    this.myChart1 = this.$echarts.init(document.getElementsByClassName('echarts_service')[0]);
                    this.myChart1.setOption({
                        tooltip:{
                            trigger: 'axis',
                            padding:0,
                            borderColor:'#fff',
                            axisPointer:{
                                lineStyle:{
                                    color:'#fff',
                                    type:'dotted',
                                }
                            },
                            formatter: function (params) {
                                var tls = `<div class="echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1"></span></p><p class="p2">${params[0].name}</p></div>`;
                               return tls;
                            },
                        },
                        grid:{
                            top:10,
                            left:40,
                            right:40,
                            bottom:40,
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: dataX,
                            axisTick:{
                                show:false
                            },
                            axisLine:{
                                show:false
                            },
                        },
                        yAxis: {
                            show:false,
                            type: 'value',
                            nameGap:6,
                            splitNumber:4,
                            axisTick:{
                                show:false,
                            },
                            axisLine:{
                                show:false
                            },
                            axisLabel:{
                                short:false,
                            }
                        },
                        series: [{
                            data: dataY,
                            type: 'bar',
                            barWidth:'50%',
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: this.version == '1'?'#8266C7':'#05CFAB' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: '#ffffff' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                }
                            },
                            // lineStyle:{
                            //     color:'#05CFAB',
                            // },
                            itemStyle:{
                                color:this.version == '1'?'#8266C7':'#05CFAB',
                            }
                        }]
                    });
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.getServiceList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getServiceList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.serviceDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.serviceDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.serviceDataIdList.length;
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:this.floorId,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        console.log(this.roomNav)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
        },
        watch:{
            hotelId:function(){
                this.currentPage = 1;
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(()=>{
                            if(this.floorNav.length > 0){
                                this.floorId = this.floorNav[0].id;
                                this.getRoomNav(()=>{
                                    if(this.roomNav.length > 0){
                                        this.roomId = this.roomNav[0].id;
                                        this.getServiceList();
                                        this.repairStatis();
                                    }else{
                                        this.roomId = '';
                                        this.roomNav = [];
                                    }
                                })
                            }else{
                                this.floorNav = [];
                                this.floorId = '';
                                this.roomNav = [];
                                this.roomId = '';
                                this.getServiceList();
                                this.repairStatis();
                            }
                        })
                    }else{
                        this.buildId = '';
                        this.floorNav = [];
                        this.floorId = '';
                        this.roomNav = [];
                        this.roomId = '';
                        this.getServiceList();
                        this.repairStatis();
                    }
                });
            },
            updateRemRatio:function(){
                // console.log(this.myChart1)
                this.$nextTick(function(){
                    if(this.myChart1){
                        this.myChart1.resize();
                    }
                })
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .service_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .service_right{
                .service_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .service_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
        }
        .service_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .service_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .service_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        margin-right: 0.5rem;
                        width: 11.42rem;
                    }
                    >.el-input{
                        // margin-left: 1rem;
                        width: 17rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .right_top_r{
                    display: flex;
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .service_echarts_box{
                margin-top: 1rem;
                height: 20.5rem;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                padding: 0 1.67rem;
                .service_title{
                    display: flex;
                    justify-content: space-between;
                    margin: 1.5rem 0 1rem;
                    .text{
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1.5rem;
                        color: #333333;
                    }
                    .flex_box{
                        display: flex;
                        align-items: center;
                        .el-dropdown{
                            cursor: pointer;

                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                            i{
                                color: #A3AFBB;
                            }
                        }
                        .el-date-editor{
                            width: 12rem;
                            .el-input__inner{
                                padding: 0 0 0 3rem;
                                height: 2.5rem;line-height: 2.5rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(101,112,133,1);
                                border: none;
                            }
                            .el-input__icon{
                                line-height: 2.5rem;
                                font-size: 1rem;
                            }
                        }
                    }
                }
                .time_box{

                }
                .echarts_service{
                    width: 100%;
                    height: calc(100% - 5rem);
                    .echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                // background: #05CFAB !important;
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }
                    }
                }
            }
            .service_right_main{
                height: calc(100% - 25rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 3.2rem;line-height: 3.2rem;
                    .main_top_l{
                        margin-left: 1.1rem;
                        display: flex;
                        .btn{
                            margin-left: 1.29rem;
                            display: flex;align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            i{
                                font-size:0.8rem;
                                color: #C6CDD5;
                            }
                            span{
                                margin-left: 0.5rem;
                            }
                        }
                    }
                    .main_top_r{
                        margin-left: 1.1rem;
                        display: flex;
                        align-items: center;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 7rem);
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                                }
                        }
                        .maintenanceStatus{
                            .text_0{
                                color: #FF0C4D;
                            }
                            .text_1{
                                color: #05cfab;
                            }
                        }
                    }
                    .pagination_box{
                        height: 2.5rem;line-height: 2.5rem;
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                            color: rgba(5,207,171,1);
                            background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .maintenanceInformation_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .maintenanceInformation_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 60rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .maintenanceInformation_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 60rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.maintenanceInformation_tk_show{
                    right: 0rem; 
                }
                .maintenanceInformation_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 2.46rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        &.fault{
                            background: rgba(255,12,77,0.05);
                            .el-input__inner{
                                color: rgba(255,12,77,1);
                            }
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 15rem);
                            .el-input__inner{
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #F6F8F7;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                    }
                }
            }
        }
        .repair_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .repair_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .repair_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.repair_tk_show{
                    right: 0rem; 
                }
                .repair_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 2.46rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        &.fault{
                            background: rgba(255,12,77,0.05);
                            .el-input__inner{
                                color: rgba(255,12,77,1);
                            }
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>